import React, { useContext } from "react";
import ProductDetails from "components/product/details";
import ProductGallery from "components/product/gallery";
import ProductPage from "./page";
import ModalRoutingContext from "context/modal-routing";

import { Head as MetaHead } from "components/head";
export const Head = ({ location, pageContext }) => {
	return <MetaHead
		location={location} pageContext={{
			...pageContext, meta: { ...pageContext.meta, title: pageContext.meta.title || pageContext.product.title }
		}} />;
};


const Product = ({ pageContext, location }) => {
	const { isModal, closeTo } = useContext(ModalRoutingContext);
	const { product = {}, language } = pageContext;

	return isModal ? (
		<>
			<ProductGallery images={product.images} />
			<ProductDetails product={product} closeModal={closeTo} lang={language} />
		</>
	) : (
		<ProductPage pageContext={pageContext} path={location.pathname} />
	);
};

export default Product;
